import { render } from "./CategoryImage.vue?vue&type=template&id=872aec24&scoped=true"
import script from "./CategoryImage.vue?vue&type=script&lang=js"
export * from "./CategoryImage.vue?vue&type=script&lang=js"

import "./CategoryImage.vue?vue&type=style&index=0&id=872aec24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872aec24"]])

export default __exports__